export enum UnitOfMeasurement {
    FEET = 'ft',
    METERS = 'm',
    YARDS = 'yd'
}

export enum ImperialSystem {
    GB = 'GB',
    US = 'US',
    MM = 'MM',
    LR = 'LR',
}

export enum DefaultRadiusValue {
    FEET = 500,
    METERS = 150,
    YARDS = 150
}

export enum MinimumRadiusValue {
    FEET = 330,
    METERS = 100,
    YARDS = 110
}
